// extracted by mini-css-extract-plugin
export default {"friends":"friends_friends__GaarH","list":"friends_list__T41BF"};